// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"777cffb9","498":"7938f31e","703":"c1d375f0"}[chunkId] + ".chunk.js";
};